import { Phone, Email, Instagram } from "@material-ui/icons";
import React from "react";

import contactInfo from "../../../content/settings/contact_info.json";
import { formatPhoneNumber } from "../../../utils/formatPhoneNumber";
import ContactForm from "../ContactForm/ContactForm";

interface ContactSectionProps {}

const ContactSection: React.FC<ContactSectionProps> = ({ children }) => {
  return (
    <section className="bg-gray-100">
      <div className="container">
        <div className="lg:flex flex-wrap justify-between space-y-8 lg:space-y-0">
          <div>
            <h3 className="text-2xl font-bold mb-4">Contact us</h3>

            <ul className="mb-8">
              <ContactListItem>{contactInfo.address.street}</ContactListItem>
              <ContactListItem>
                {contactInfo.address.city}, {contactInfo.address.zipCode},{" "}
                {contactInfo.address.state}
              </ContactListItem>
            </ul>

            <ul className="mb-8">
              <ContactListItem>
                <div className="flex items-center">
                  <Phone className="mr-2" />
                  <a href={`tel:${contactInfo.phone}`}>
                    {formatPhoneNumber(contactInfo.phone)}
                  </a>
                </div>
              </ContactListItem>
              <ContactListItem>
                <div className="flex items-center">
                  <Email className="mr-2" />
                  <a href={`mailto:${contactInfo.email}`}>
                    {contactInfo.email}
                  </a>
                </div>
              </ContactListItem>
            </ul>

            <h3 className="text-2xl font-bold mb-4">Follow us</h3>

            <ul>
              <ContactListItem>
                <a
                  href={contactInfo.socialMedia.instagram}
                  target="_blank"
                  rel="noreferrer"
                >
                  <Instagram />
                </a>
              </ContactListItem>
            </ul>
          </div>
          <div className="max-w-xl w-full">
            <h3 className="text-2xl font-bold mb-4">Leave us a message</h3>
            {children ? <p className="mb-8">{children}</p> : null}

            <ContactForm />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;

interface ContactListItemProps {}

const ContactListItem: React.FC<ContactListItemProps> = ({ children }) => {
  return <li className="mb-2 last:mb-0">{children}</li>;
};
